import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ACTIONS, URLS } from '../../_config';
import { useUserApi } from '../../store/api/hooks/userApiHook';
import { useForm } from 'react-hook-form';
import Icon from '../../components/icons';
import { useStoreSelector, useAuthStatus } from '../../store/selectors/userSelector';
import { useStoreApi } from '../../store/api/hooks/storeApiHook';
import { useDataSourceApi } from '../../store/api/hooks/dataSourceApiHook';
import toast from 'react-hot-toast';
import Spinner from '../../components/iconSvgs/spinner';

const Branches: React.FC = () => {
    const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);
    const [branches, setBranches] = useState<any[]>([]);
    const [selectedBranch, setSelectedBranch] = useState<any>(null);

    const storeAPI: any = useStoreApi();
    const dataSourceAPI = useDataSourceApi();
    const navigate = useNavigate();
    const isAuth = useAuthStatus();
    const store = useStoreSelector();
    const dispatch = useDispatch();
    // console.log('store =>', store?.store_id);

    const { register, formState: { errors }, handleSubmit, } = useForm<any>();

    const getBranches = (data: any) => {
        storeAPI.getStoreBranches(data, (msg: any, resp: any) => {
            // console.log('response =>', resp, msg);
            setBranches(resp.data);
        }, (err: any) => {
            toast.error(err);
        })
    }

    const handleBranchChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        // const selectedBranchId = e.target.value;
        const currentSelectedBranch = JSON.parse(e.target.value); 
        setSelectedBranch(currentSelectedBranch);
    };

    const onSubmit = () => {
        setOnSubmitLoading(true);
        const param: any = {
            branch_id: selectedBranch?.branch_id,
        }
        try {
            setTimeout(() => {
                dataSourceAPI.getDataSource(param, (msg: any, resp: any) => {
                    if (resp?.code === 200) {
                        if (resp.data.length > 0) {
                            let inPending: any = null;
                            let failure: any = null;
                            const completed = resp?.data.find((item: any) => item.last_fetch_status === 'completed');
                            if (!completed) {
                                inPending = resp?.data.find((item: any) => item.last_fetch_status === 'pending');
                                if (!inPending) {
                                    failure = resp?.data.find((item: any) => !item.last_fetch_status);
                                }
                            }
                            if (completed) {
                                dispatch({
                                    type: ACTIONS.STORE.GET_BRANCH,
                                    payload: completed,
                                })
                                navigate(URLS.DASHBOARD);
                            } else if (inPending) {
                                dispatch({
                                    type: ACTIONS.STORE.GET_BRANCH,
                                    payload: inPending,
                                })
                                navigate(URLS.DATASOURCES.LIST);
                            } else {
                                dispatch({
                                    type: ACTIONS.STORE.GET_BRANCH,
                                    payload: failure,
                                })
                                navigate(URLS.DATASOURCES.LIST);
                            }
                        }
                    } else if (resp?.code === 404) {
                        toast.error(resp?.message);
                        const payload = {
                            source_type: null,
                            url: null,
                            last_fetch_date: null,
                            created_at: null,
                            ds_id: null,
                            store_id: store?.store_id,
                            branch_id: selectedBranch?.branch_id,
                            branch_name: selectedBranch?.branch_name,
                            snapshot_id: null,
                            last_fetch_status: null
                        }
                        dispatch({
                            type: ACTIONS.STORE.GET_BRANCH,
                            payload: payload,
                        })
                        navigate(URLS.DATASOURCES.CREATE);
                    }
                }, (error: any, resp: any) => {
                    console.log('error =>', error, resp);
                    if (resp?.detail?.code === 404) {
                        toast.error(resp?.detail?.message);
                        const payload = {
                            source_type: null,
                            url: null,
                            last_fetch_date: null,
                            created_at: null,
                            ds_id: null,
                            store_id: store?.store_id,
                            branch_id: selectedBranch?.branch_id,
                            branch_name: selectedBranch?.branch_name,
                            snapshot_id: null,
                            last_fetch_status: null
                        }
                        // console.log('payload =>,', payload);
                        dispatch({
                            type: ACTIONS.STORE.GET_BRANCH,
                            payload: payload,
                        })
                        navigate(URLS.DATASOURCES.CREATE);
                        // navigate(URLS.SETTINGS);
                    } else {
                        toast.error("Something went wrong");
                    }
                })
                setOnSubmitLoading(false);
            }, 5000);
        } catch (err: any) {
            toast.error(err);
            setOnSubmitLoading(false);
        }
    };

    useEffect(() => {
        if(store?.store_id){
            getBranches({store_id: store?.store_id});
        }
    }, [store]);

    return (
        <div className="flex min-h-screen">
            {isOnSubmitLoading && (
                <div className="absolute inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50">
                    <Spinner className="self-center z-50" />
                </div>
            )}
            {/* Left Side: Form Section */}
            <div className="flex flex-col justify-center items-center w-full lg:w-4/12 sm:w-4/12 px-6 py-12 lg:px-8 bg-white">
                <div className="sm:mx-auto sm:w-full sm:max-w-2xl">
                    <img className="h-15 w-auto mb-[92px]" src="/assets/images/Frame_2.png" alt="hubwallet logo" />
                    <h2 className="mt-10 text-left text-2xl font-bold tracking-tight text-gray-900">Branches</h2>
                    <p className="mt-1 text-left text-base tracking-tight text-gray-500">Choose a branch store</p>
                </div>

                <div className="mt-5 sm:mx-auto sm:w-full sm:max-w-2xl">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="mb-5">
                            <div className="mt-2 relative">
                                <select {...register("branch", { required: true })}
                                    className={`block-lg w-full rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-500 outline outline-1 -outline-offset-1 ${errors.storeType ? 'outline-red-500 outline-2' : 'outline-gray-300'} focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm focus`}
                                    id="selectBranch"
                                    value={selectedBranch ? JSON.stringify(selectedBranch) : ""}
                                    style={{
                                        appearance: 'none',
                                        WebkitAppearance: 'none', 
                                        MozAppearance: 'none', 
                                        backgroundImage: 'none', 
                                    }}
                                    onChange={(e) => handleBranchChange(e)}
                                >
                                    <option value="" disabled className='text-gray-400'>
                                        Branch
                                    </option>
                                    {branches.length > 0 ? (
                                        branches.map((brn: any, index: any) => (
                                            <option key={index} value={JSON.stringify(brn)} className="text-gray-500 pointer-events-auto">
                                                {brn.branch_name} 
                                            </option>
                                        ))
                                    ) : null}
                                </select>
                                <Icon name="arrow-down" size={20} className="absolute right-3 top-[25px] transform -translate-y-1/2 text-gray-400" />

                            </div>
                        </div>

                        <div className="mb-5">
                            <button
                                type="submit"
                                className="flex w-full justify-center rounded-sm bg-blue-500 p-4 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                            >
                                Submit
                            </button>
                        </div>
                    </form>


                </div>
            </div>

            <div className="hidden sm:block lg:w-8/12 sm:w-8/12 bg-cover" style={{ backgroundImage: 'url(/assets/images/2148204009-1.jpg)' }}>
            </div>
        </div>
    );
};

export default Branches;